import { useForm } from "react-hook-form";
import TextField from "../../../components/UI/TextField";
import useFlightStore from "../../../store/flightStore";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuthStore } from "../../../store/authStore";
import moment from "moment";
import { getallmission } from "../../../api/missionAPI";
import { useEffect, useState } from "react";
import { getAssignedDrones, getalldrones } from "../../../api/dronesAPI";
import { flightReason } from "../../../helpers/constants";
import { addFlight } from "../../../api/flightsAPI";
import { getAllPilots } from "../../../api/authAPI";
import useDroneStore from "../../../store/droneStore";
import { ToastContainer } from "react-toastify";

const BookFlightModal = ({ startTime, endTime }) => {
    const { setAllPilots, allPilots } = useDroneStore((state) => state)
    const [searchQuery, setSearchQuery] = useState('');
    const [userId, setUserId] = useState("");
    const { token, toast, setLoaderState, isPilot, user } = useAuthStore((state) => state);
    const assignedDrones = useQuery([token, userId], () => getAssignedDrones(token, userId), { enabled: userId != "" })
    const { data: missionData } = useQuery({
        queryFn: getallmission,
        queryKey: ["getMissionsInFlights", token],
    });
    const qClient = useQueryClient();

    const {
        register,
        handleSubmit,
        getValues,
        reset,
        watch
    } = useForm();

    const flightReasonVal = watch("flightReason")
    const { setShowBookFlightModal } = useFlightStore((state) => state);


    const flight = useMutation({
        mutationFn: addFlight,
        onSuccess: () => {
            setShowBookFlightModal(false);
            // refetch on submit
            setLoaderState(false)
            qClient.invalidateQueries({ queryKey: "getFlights" });
            toast("success", "Flight Booked Successfully")
        },
    });

    const pilots = useQuery(["getAllUser", token], () => getAllPilots(token), { enabled: true })

    useEffect(() => {
        setAllPilots(pilots?.data?.data?.data)
        if (userId == "" && pilots?.data?.data?.data[0]) {
            setUserId(pilots?.data?.data?.data[0]?.userId)
        }
    }, [pilots?.data?.data])


    useEffect(() => {
        if (userId == "" && pilots?.data?.data?.data[0]) {
            setUserId(pilots?.data?.data?.data[0]?.userId)
        }
        // if (isPilot) {
        //     setUserId(user?._id)
        // }
    }, [])

    const onSubmit = () => {
        let payload = getValues();
        if (isPilot) {
            payload = { ...payload, assignTo: "" }
        }
        if (token && payload) {
            payload = { ...payload, assignTo: userId }
            setLoaderState(true)
            flight.mutate({ token, payload });
            reset()
            // waypointForm.reset();
        }
    }

    useEffect(() => {
        if (isPilot) {
            setUserId(user?._id)
        }
    }, [isPilot])

    useEffect(() => {
        if (flight?.error) {
            setLoaderState(false)
            console.log("test")
            toast("error", flight.error?.response?.data?.message)
        }
    }, [flight.error, flight.data?.data])

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
    };

    const filteredMissions = missionData?.data?.data?.filter((mission) =>
        mission.missionName.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div className="grid place-items-center w-screen h-screen fixed z-50 bg-black/25 backdrop-blur inset-0">
            <ToastContainer />
            <div id="defaultModal" aria-hidden="true" className="p-4 overflow-x-hidden md:inset-0 ">
                <div className="relative max-w-xl">
                    <div className="relative bg-white rounded-lg dark:bg-white">
                        <div className="flex items-start justify-between p-4 border-b rounded-t dark:border-gray-600">
                            <h3 className="text-2xl text-gray-900 font-semibold">
                                Book Flight
                            </h3>
                            <button onClick={() => { setShowBookFlightModal(false) }} type="button" className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-red-500 dark:hover:text-white" data-modal-hide="defaultModal">
                                <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                <span className="sr-only">Close modal</span>
                            </button>
                        </div>
                        <div className="p-6 space-y-6 h-[51vh] overflow-y-auto">
                            <div className="grid grid-cols-2">
                                <div className="pr-2">
                                    <span>
                                        <TextField
                                            label="Start Time*"
                                            placeholder="Enter Start Time..."
                                            type="datetime-local"
                                            inputProps={
                                                {
                                                    ...register("flightStartTime", { required: true }),
                                                    defaultValue: moment(startTime).format("YYYY-MM-DDTHH:mm")

                                                }
                                            }
                                        />
                                    </span>
                                </div>
                                <div className="pr-2">
                                    <span>
                                        <TextField
                                            label="End Time*"
                                            placeholder="Enter Start Time..."
                                            type="datetime-local"
                                            inputProps={
                                                {
                                                    ...register("flightEndTime", { required: true }),
                                                    defaultValue: moment(endTime).format("YYYY-MM-DDTHH:mm")
                                                }
                                            }
                                        />
                                    </span>
                                </div>
                                <div className="pr-2">
                                    <span>
                                        <h2 className="text-tblu">Select mission*</h2>
                                        <input
                                            type="text"
                                            value={searchQuery}
                                            onChange={handleSearch}
                                            placeholder="Search missions"
                                            className="w-full my-2 block p-4 border-slate-200 border rounded-xl focus:outline-none mb-4"
                                        />
                                        <select
                                            {...register("missionId", { required: true })}
                                            className="w-full my-2 block p-4 border-slate-200 border rounded-xl focus:outline-none mb-4"
                                        >
                                            {filteredMissions?.map((mission, index) => (
                                                <option key={index} value={mission._id}>
                                                    {mission.missionName}
                                                </option>
                                            ))}
                                        </select>
                                    </span>
                                </div>
                                <div className="pr-2">
                                    <span>
                                        <h2 className="text-tblu">Select drone*</h2>
                                        {assignedDrones?.data?.data?.data?.length > 0 ?
                                            <select
                                                {...register("droneId", { required: true })}
                                                className="w-full my-2 block p-4 border-slate-200 border rounded-xl focus:outline-none"
                                            >
                                                {assignedDrones?.data?.data?.data?.map((drone, index) => (
                                                    <option key={index} value={drone?.droneId?.droneId}>
                                                        {drone?.droneId?.droneName}
                                                    </option>
                                                ))}
                                            </select> : <h1 className="text-zinc-400 text-center py-5 font-extrabold text-lg">No Drone Assigned</h1>}
                                    </span>
                                </div>
                                {isPilot ? <div className="pr-2">
                                    <span>
                                        <TextField
                                            label="Pilot LicenseNo.*"
                                            placeholder={`${user?.licenseNumber}`}
                                            inputProps={{
                                                ...register("pilotLicenseNumber", { required: true, disabled: true })
                                            }}
                                        />
                                    </span>
                                </div> :
                                    <div className="pr-2">
                                        <span>
                                            <h2 className="text-tblu">Pilot *</h2>
                                            <select
                                                // {...register("pilotLicenseNumber", { required: true })}
                                                className="w-full my-2 block p-4 border-slate-200 border rounded-xl focus:outline-none"
                                                onChange={(e) => {
                                                    setUserId(e.target.value);
                                                }}
                                            >
                                                {allPilots?.map((pilot, index) => (
                                                    <option key={index} value={pilot?.userId}>
                                                        {pilot.fullName}
                                                    </option>
                                                ))}
                                            </select>

                                        </span>
                                    </div>
                                }
                                <div className="pr-2">
                                    <span>
                                        <h2 className="text-tblu">Reason For Flight*</h2>
                                        <select
                                            {...register("flightReason", { required: true })}
                                            className="w-full my-2 block p-4 border-slate-200 border rounded-xl focus:outline-none"
                                        >
                                            {flightReason.map((reason, index) => (
                                                <option key={index} value={reason}>
                                                    {reason}
                                                </option>
                                            ))}
                                        </select>
                                    </span>
                                </div>
                            </div>

                            <div>
                                <div>
                                    <TextField
                                        placeholder={"Add a description"}
                                        inputProps={{ ...register("flightDescription", { required: (flightReasonVal === "other") }) }}
                                        label={`flight Reason description ${flightReasonVal === "other" ? "(Required)" : "(Optional)"}`}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center w-full justify-center pt-0 p-6 space-x-2 rounded-b ">
                            <button onClick={handleSubmit(onSubmit)} disabled={assignedDrones?.data?.data?.data?.length > 0 ? false : true} data-modal-hide="defaultModal" type="button" className={`text-white w-full ${(assignedDrones?.data?.data?.data?.length) > 0 ? "bg-tblu dark:bg-tblu dark:hover:bg-tblu dark:focus:ring-tblu hover:bg-tblu" : "bg-zinc-400 dark:bg-zinc-400 dark:hover:bg-zinc-400 dark:focus:ring-zinc-400 hover:bg-zinc-400"}  focus:ring-4 focus:outline-none focus:ring-tblu font-medium rounded-lg text-sm px-5 py-2.5 text-center  `}>Submit</button>
                        </div>
                        <p className="text-gray-400 p-6 pt-0 text-sm">*Flight approvals are initially granted by the system but subject to change. Prior to departure, please ensure to verify the latest status.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BookFlightModal;